import React, { useEffect, useState } from "react";
import { TelegramLogo, MagnifyingGlass, User, UsersThree } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import {
  fetchTrackerSettings,
  telegramDetect,
  setTelegramChatId,
  setTelegramGroupChatId,
} from "../lib/api";
import { formatApiError } from "../lib/auth";

function ChatChoice({ chat, onPick }) {
  const isGroup = chat.type !== "private";
  const name = chat.title || [chat.first_name, chat.last_name].filter(Boolean).join(" ") || chat.username;
  return (
    <button
      onClick={() => onPick(chat)}
      data-testid={`telegram-detected-${chat.chat_id}`}
      className="w-full text-left border border-zinc-300 hover:border-zinc-950 px-3 py-2 font-mono text-xs flex items-center gap-2 transition-colors duration-150"
    >
      {isGroup ? <UsersThree size={14} weight="bold" /> : <User size={14} weight="bold" />}
      <span className="font-bold truncate">{name}</span>
      <span className="text-zinc-500 ml-auto shrink-0">{chat.chat_id}</span>
    </button>
  );
}

export function TelegramRecipients() {
  const [s, setS] = useState(null);
  const [chats, setChats] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => fetchTrackerSettings().then(setS).catch(() => {});
  useEffect(() => { load(); }, []);

  const detect = async () => {
    setBusy(true);
    try {
      const res = await telegramDetect();
      setChats(res.chats || []);
      if (!res.chats?.length) toast.info("No veo chats. Escribe un mensaje en el grupo y vuelve a detectar.");
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudo detectar");
    }
    setBusy(false);
  };

  const pick = async (chat) => {
    const isGroup = chat.type !== "private";
    try {
      await (isGroup ? setTelegramGroupChatId : setTelegramChatId)(chat.chat_id);
      toast.success(isGroup ? "Grupo guardado" : "Chat privado guardado");
      load();
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudo guardar");
    }
  };

  if (!s) return null;
  return (
    <div className="border-2 border-zinc-950 p-4 bg-white" data-testid="telegram-recipients">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#0088cc] mb-3 flex items-center gap-1">
        <TelegramLogo size={14} weight="bold" /> Destinos de Telegram
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-mono text-xs">
        <div className="border border-zinc-200 px-3 py-2" data-testid="recipient-private">
          Privado: <b>{s.telegram_chat_id || "— no configurado"}</b>
        </div>
        <div className={`border px-3 py-2 ${s.telegram_group_chat_id ? "border-zinc-200" : "border-red-400 bg-red-50 text-red-700"}`} data-testid="recipient-group">
          Grupo: <b>{s.telegram_group_chat_id || "— no configurado"}</b>
        </div>
      </div>
      <Button onClick={detect} disabled={busy} variant="outline" className="rounded-none border-zinc-950 font-mono uppercase text-xs mt-3" data-testid="telegram-detect-button">
        <MagnifyingGlass size={14} weight="bold" className="mr-2" /> {busy ? "Buscando..." : "Detectar chats / grupos"}
      </Button>
      {chats?.length > 0 && (
        <div className="mt-3 space-y-1">
          <p className="font-mono text-[11px] text-zinc-500">Toca un chat para guardarlo como destino:</p>
          {chats.map((c) => <ChatChoice key={c.chat_id} chat={c} onPick={pick} />)}
        </div>
      )}
    </div>
  );
}
